export default __webpack_public_path__ + "static/media/ap4.24d038b7.png";